import { render, staticRenderFns } from "./TreeselectEntity.vue?vue&type=template&id=6d22be07"
import script from "./TreeselectEntity.vue?vue&type=script&lang=js"
export * from "./TreeselectEntity.vue?vue&type=script&lang=js"
import style0 from "./TreeselectEntity.vue?vue&type=style&index=0&id=6d22be07&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports